import React from 'react';
import { Link } from 'react-router-dom';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import { navigationItems } from '../../../../../utils/constants';
import { useAuth } from '../../../../contexts/userContext/userContext';
import { ReactComponent as User } from '../../../../../resources/images/svg/account.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { ReactComponent as Logout } from '../../../../../resources/images/header-icons/logout.svg';

function ProfileNavigationDrawer() {
  const { showProfileDrawer, setShowProfileDrawer } = useModal();
  const { user, resetUser, accessToken } = useAuth();
  const { trans } = useTranslation();

  const handleLogOut = () => {
    resetUser();
    setShowProfileDrawer(false);
  };
  return (
    <DefaultDrawer
      show={accessToken && showProfileDrawer}
      setShow={setShowProfileDrawer}
      wra
      style={{
        maxHeight: 500,
        height: '100%',
      }}
      wrapperStyle={{
        height: 500,
      }}
      className="nav-drawer"
    >
      <ul className="flex flex-col gap-9">
        <li className="list-none text-lg font-bold cursor-pointer">
          <Link
            to="profile"
            className="flex gap-3 items-center text-black font-big"
            onClick={() => setShowProfileDrawer(false)}
          >
            <User className="h-5 w-5" />
            {user?.type === 'physical' ? `${user?.first_name} ${user?.last_name?.[0]}.` : user?.name}
          </Link>
        </li>
        {navigationItems.map((item) => (
          <li key={item.id} className="list-none text-lg font-bold cursor-pointer">
            <Link
              to={item.link}
              className="flex gap-3 items-center text-black font-big"
              onClick={() => setShowProfileDrawer(false)}
            >
              {item.icon}
              {trans(item.text)}
            </Link>
          </li>
        ))}
        <li className="list-none text-lg font-bold cursor-pointer">
          <Link
            to="/ka"
            className="flex gap-3 items-center text-black font-big"
            onClick={handleLogOut}
          >
            <Logout className="h-5 w-5" />

            {trans('logout')}
          </Link>
        </li>
      </ul>
    </DefaultDrawer>
  );
}

export default ProfileNavigationDrawer;
